import React, { useState, useMemo, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useUnreadContext } from './unread'
import { useMessagesContext } from './all'
import { getUnreadCount } from '../../libs/store/lists/unread'

export function useMessageType() {
  const [ showUnread, setShowUnread ] = useState(true)
  const { 
    messages: unreadMessages, 
    loading: unreadLoading,
    page: unreadPage,
    setPage: setUnreadPage } = useUnreadContext()

  const { 
    messages: allMessages, 
    loading: allLoading,
    page: allPage,
    total: allTotal,
    setPage: setAllPage } = useMessagesContext()

  useEffect(() => {
    if (showUnread) {
      setAllPage(null)
      setUnreadPage(0)
    } else {
      setAllPage(0)
    }
  }, [showUnread])

  const unreadTotal = useSelector(getUnreadCount)

  const messages = showUnread ? unreadMessages : allMessages
  const loading = showUnread ? unreadLoading : allLoading
  const page = showUnread ? unreadPage : allPage
  const setPage = showUnread ? setUnreadPage : setAllPage
  const total = showUnread ? unreadTotal : allTotal
  const finishedPaging = (messages.length == total)

  return useMemo(() => ({
    showUnread, setShowUnread,
    messages, total, loading, page, setPage, finishedPaging
  }), [showUnread, total, messages, loading, page, setPage, finishedPaging])
}